import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/member/ALangsetGroup/index",{
        params: {
            ...params
        }
    } )
}
function SUBMIT_ADDLIST(params) {
    return  axios.post("/member/ALangsetGroup/addPost",{...params} )
}
function GET_DATA(params) {
    return axios.get("/member/ALangsetGroup/edit",{   params: {
            id: params
        } } )
}
function SUBMIT_EDITDATA(params) {
    return axios.post("/member/ALangsetGroup/editPost",{...params} )
}

function DELE(params) {
    return  axios.get("/member/ALangsetGroup/delete",{
        params: {
            id:params
        }
    } )
}

export default {
    GET_LIST,
    SUBMIT_ADDLIST,
    GET_DATA,
    SUBMIT_EDITDATA,
    DELE,
};